/* global document, Drupal, jQuery */
(($) => {
  Drupal.behaviors.verticalVideos = {
    attach: () => {
      $('body').once('summit-verticalvideos').each(() => {

        document.querySelectorAll('.paragraph--type-vertical-videos').forEach((paragraph) => {

          // paragraph.querySelectorAll('.tiktok-video-wrapper').forEach((wrapper) => {
          //   const videoId = wrapper.dataset.tiktokId;
          //   const videoUrl = wrapper.dataset.tiktokUrl;
          //   const playButton = wrapper.querySelector('.play-video');

          //   if (!videoId || !playButton) return;

          //   // Inject TikTok iframe if not already present
          //   let iframe = wrapper.querySelector('iframe');
          //   if (!iframe) {
          //     iframe = document.createElement('iframe');
          //     iframe.src = `https://www.tiktok.com/player/v1/${videoId}?autoplay=0`;
          //     iframe.width = 325;
          //     iframe.height = 570;
          //     iframe.frameBorder = 0;
          //     iframe.allow = 'autoplay; fullscreen';
          //     wrapper.insertBefore(iframe, playButton);
          //   }

          //   // Apply aspect ratio styling (9:16)
          //   wrapper.style.position = 'relative';
          //   wrapper.style.paddingTop = '177%';
          //   wrapper.style.overflow = 'hidden';
          //   iframe.style.position = 'absolute';
          //   iframe.style.top = 0;
          //   iframe.style.left = 0;
          //   iframe.style.width = '100%';
          //   iframe.style.height = '100%';

          //   // Play button overlay
          //   playButton.style.position = 'absolute';
          //   playButton.style.top = '50%';
          //   playButton.style.left = '50%';
          //   playButton.style.transform = 'translate(-50%, -50%)';
          //   playButton.style.zIndex = 2;

          //   let hovered = false;
          //   let clicked = false;

          //   let thumb = wrapper.querySelector('.tiktok-thumb');
          //   console.log('Thumbnail element:', thumb);
          //   if (!thumb) {
          //     console.log('Fetching TikTok thumbnail for', videoUrl);
          //     thumb = document.createElement('img');
          //     thumb.className = 'tiktok-thumb';
          //     thumb.style.position = 'absolute';
          //     thumb.style.top = 0;
          //     thumb.style.left = 0;
          //     thumb.style.width = '100%';
          //     thumb.style.height = '100%';
          //     thumb.style.objectFit = 'cover';
          //     thumb.style.zIndex = 2;
          //     wrapper.insertBefore(thumb, iframe);

          //     // Fetch thumbnail from TikTok oEmbed
          //     fetch(`https://www.tiktok.com/oembed?url=${encodeURIComponent(videoUrl)}`)
          //       .then((res) => res.json())
          //       .then((data) => {
          //         if (data && data.thumbnail_url) {
          //           thumb.src = data.thumbnail_url;
          //         }
          //       })
          //       .catch((err) => console.warn('TikTok oEmbed error', err));
          //   }

          //   const hideThumb = () => {
          //     if (thumb) thumb.style.display = 'none';
          //   };

          //   // Hover: muted preview
          //   const onMouseEnter = () => {
          //     if (clicked) return; // do nothing after click
          //     hovered = true;
          //     iframe.contentWindow.postMessage({
          //       type: "mute",
          //       value: 0,
          //       "x-tiktok-player": true
          //     }, '*');
          //     iframe.contentWindow.postMessage({
          //       type: "play",
          //       value: 0,
          //       "x-tiktok-player": true
          //     }, '*');
          //     hideThumb();
          //   };

          //   const onMouseLeave = () => {
          //     if (clicked) return; // do nothing after click
          //     hovered = false;
          //     iframe.contentWindow.postMessage({
          //       type: "pause",
          //       value: 0,
          //       "x-tiktok-player": true
          //     }, '*');
          //   };

          //   playButton.addEventListener('mouseenter', onMouseEnter);
          //   playButton.addEventListener('mouseleave', onMouseLeave);

          //   // Click: full unmuted play
          //   playButton.addEventListener('click', () => {
          //     clicked = true;

          //     // Unbind hover events so they don't interfere
          //     playButton.removeEventListener('mouseenter', onMouseEnter);
          //     playButton.removeEventListener('mouseleave', onMouseLeave);

          //     iframe.contentWindow.postMessage({
          //       type: "seekTo",
          //       value: 0,
          //       "x-tiktok-player": true
          //     }, '*');
          //     iframe.contentWindow.postMessage({
          //       type: "unMute",
          //       value: 0,
          //       "x-tiktok-player": true
          //     }, '*');
          //     iframe.contentWindow.postMessage({
          //       type: "play",
          //       value: 0,
          //       "x-tiktok-player": true
          //     }, '*');

          //     // Hide play button after click
          //     playButton.style.display = 'none';
          //   });

          // });

          // Initialize slick carousel
          // const videos = paragraph.querySelector('.field--name-field-videos');
          // if (videos && !$(videos).hasClass('slick-initialized')) {
          //   $(videos).slick({
          //     slidesToShow: 4,
          //     slidesToScroll: 1,
          //     mobileFirst: false,
          //     centerMode: false,
          //     draggable: false,
          //     infinite: false,
          //     speed: 800,
          //     swipeToSlide: true,
          //     responsive: [
          //       { breakpoint: 1190, settings: { slidesToShow: 3 } },
          //       { breakpoint: 830, settings: { slidesToShow: 2 } },
          //       { breakpoint: 600, settings: { slidesToShow: 1 } },
          //     ],
          //   });
          // }

        });
      });
    },
  };
})(jQuery);
